import React, { Fragment } from 'react'
import { useSelector } from 'react-redux';

const DetailsInput = (props) => {
    const { label, value, type } = props;
    const WebsiteLanguage = useSelector((state) => state.WebsiteLanguage.data.language);
    const GeneralTranslations = useSelector((state) => state.WebsiteLanguage.data.GeneralTranslations);
    const ControlsTranslations = useSelector((state) => state.WebsiteLanguage.data.ControlsTranslations);

    let valueText = value;

    if (type === 'Gender') {
        if (value === 1) {
            valueText = '*';
        } else if (value === 2) {
            valueText = '*';
        }
    } else if (type === 'LlojiShkeljes') {
        if (value === '1' && WebsiteLanguage === 'sq') {
            valueText = `${GeneralTranslations.nondeclarationAssets}`;
        } else if (value === '1' && WebsiteLanguage === 'en') {
            valueText = `${GeneralTranslations.nondeclarationAssets}`;
        } else if (value === '1' && WebsiteLanguage === 'sr') {
            valueText = `${GeneralTranslations.nondeclarationAssets}`;
        } else if (value === '2' && WebsiteLanguage === 'sq') {
            valueText = `${GeneralTranslations.nondeclarationGifts}`;
        } else if (value === '2' && WebsiteLanguage === 'en') {
            valueText = `${GeneralTranslations.nondeclarationGifts}`;
        } else if (value === '2' && WebsiteLanguage === 'sr') {
            valueText = `${GeneralTranslations.nondeclarationGifts}`;
        }
    } else if (type === 'Bool') {
        if (value === true && WebsiteLanguage === 'sq') {
            valueText = `${ControlsTranslations.yes}`;
        } else if (value === false && WebsiteLanguage === 'sq') {
            valueText = `${ControlsTranslations.no}`;
        } else if (value === true && WebsiteLanguage === 'en') {
            valueText = `${ControlsTranslations.yes}`;
        } else if (value === false && WebsiteLanguage === 'en') {
            valueText = `${ControlsTranslations.no}`;
        } else if (value === true && WebsiteLanguage === 'sr') {
            valueText = `${ControlsTranslations.yes}`;
        } else if (value === false && WebsiteLanguage === 'sr') {
            valueText = `${ControlsTranslations.no}`;
        }
    }

    return (
        <Fragment>
            {value !== null &&
                <div className="details-field">
                    <label className='mantine-TextInput-label details-label'>{label}</label>
                    <span>{valueText}</span>
                </div>
            }
        </Fragment>
    )
}

export default DetailsInput